/**
 * Function that can replace spaces in the partner number string(for requests etc.)
 * @param partnerNumber partner number
 * @returns partner number in the correct format(without spaces)
 */
export const getPartnerNumberWithoutSpaces = (partnerNumber: string): string => {
  const partnerNumberRegexp = new RegExp(/^(\d(\s)?){12}$/)
  const isPartnerNumber = partnerNumberRegexp.test(partnerNumber)

  if (isPartnerNumber) {
    return partnerNumber.replaceAll(' ', '')
  }

  return partnerNumber
}

/**
 * Function which transforms the partner number string to the view format
 * @param partnerNumber partner number
 * @returns partner number in the view format(with spaces)
 */
export const getPartnerNumberWithSpaces = (partnerNumber: string | number): string =>
  partnerNumber
    .toString()
    .match(/.{1,4}/g)
    ?.join(' ') ?? `${partnerNumber}`
